import Vue from '_lib/_vue';
import App from './index.vue';
Vue.config.productionTip = false;

import { HbLoading } from '@heybox-components/heybox-ui';
Vue.use(HbLoading);

import reportPlugin from '_lib/plugin/heybox-report.js';
Vue.use(reportPlugin);

new Vue({
  render: (h) => h(App),
}).$mount('#app');
